import { useCallback } from 'react';
import debounce from 'lodash.debounce';
import Input from '../input/input';

const SearchBar = ({
  searchText,
  onSearch,
  setSearchText,
  label,
  placeholder,
}) => {
  const debouncedSearch = useCallback(debounce(onSearch, 500), []);

  return (
    <Input
      name="search-input"
      autoFocus
      label={label}
      value={searchText}
      placeholder={placeholder}
      valid
      onChange={(event) => {
        setSearchText(event.target.value);
        debouncedSearch(event.target.value);
      }}
    />
  );
};

export default SearchBar;
